import { ReactNode } from "react";
import { getPaypalClientId } from "../../store/utils";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PayPalScriptOptions } from "@paypal/paypal-js/types/script-options";

const paypalScriptOptions: PayPalScriptOptions = {
  "client-id": getPaypalClientId,
};
export const PayPalProvider = ({ children }: { children: ReactNode }) => (
  <PayPalScriptProvider options={paypalScriptOptions}>
    {children}
  </PayPalScriptProvider>
);
